export default [
    {
        value: "PassagemDivulgacaoResultados",
        text: "Passagem de divulgação de resultados"
    },
    {
        value: "DiariaDivulgacaoResultados",
        text: "Diária de divulgação de resultados"
    },
    {
        value: "PassagemAneel",
        text: "Passagem ANEEL"
    },
    {
        value: "DiariaAneel",
        text: "Diária ANEEL"
    },
    {
        value: "PassagemCurso",
        text: "Passagem curso"
    },
    {
        value: "DiariaCurso",
        text: "Diária de curso"
    },
    {
        value: "PassagemEvento",
        text: "Passagem de evento"
    },
    {
        value: "DiariaEvento",
        text: "Diária de evento"
    },
    {
        value: "PassagemProspeccaoTecnologica",
        text: "Passagem prospecção tecnológica"
    },
    {
        value: "DiariaProspeccaoTecnologica",
        text: "Diária prospecção tecnológica"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]